export const FlowConstants = {
  APP_RECEIVED: "appReceived",
  ACCEPT_WAIVER: "acceptWaiver",
  UPLOAD_PHOTO: "uploadPhoto",
  INFO_SESSION: "attendInfoSession",
  BACKGROUND_CHECK: "backgroundCheck",
  SELECT_OPPORTUNITIES: "selectOpportunities",
  ORIENTATION: "orientation"
};
